<template>
  <div>
    <NavigationDrawer />
    <v-col class="wrap">
      <Card />
    </v-col>
    <div class="wrap">

      <ExclusiveServicesCarousel/>
    </div>
  </div>
</template>
<script>
import Card from "@/components/Elements/Card.vue";
import NavigationDrawer from "@/views/Dashboard/NavigationDrawer.vue";
import BriOfferingsCarousel from "@/components/DashboardComponents/BriOfferingsCarousel.vue";
import ExclusiveServicesCarousel from "@/components/DashboardComponents/ExclusiveServicesCarousel.vue";

export default {
  components: {
    Card,
    NavigationDrawer,
    ExclusiveServicesCarousel,
    BriOfferingsCarousel
  }
};
</script>

<style scoped>
  .wrap {
    padding: 0 200px;
  }
</style>